import { COMPONENT_KEY } from '../constants';

const en = {
  [COMPONENT_KEY]: {
    TITLE_PAGE_ZERO: 'An error occurred',
    DESCRIPTION_PAGE_ZERO: 'Please update or try again later.',
    BUTTON_PAGE_ZERO: 'Retry',
    TITLE_PAGE_NOT_FOUND: 'Page not found',
    DESCRIPTION_PAGE_NOT_FOUND:
      'The page does not exist or has not been found.',
    BACK: 'Go back',
    TITLE_PAGE_ZERO_NOT_PROCES: 'You are not part of any process yet!',
    MY_PID: 'My PID',
    MY_TEAM: 'my team',
    PID_TITLE: 'Individual Development Plan',
    PID_DESCRIPTION: 'Individual Development Plan',
    performance: 'Performance',
    PID: 'P.I.D.',
  },
};

export default en;
